export default __webpack_public_path__ + "static/bagual-bf291d36e96e4ea31c840486998cb223.png";